import { createContext } from 'react';

const BlockChainAPIContext = createContext({});

export default BlockChainAPIContext;
